import client from './client'
import type { Sponsor, SponsorFormData } from '@/types/sponsors'

const base = (eventSlug: string, editionSlug: string): string =>
  `/organizer/events/${eventSlug}/editions/${editionSlug}/sponsors`

export async function listSponsors(eventSlug: string, editionSlug: string): Promise<Sponsor[]> {
  const { data } = await client.get<{ data: Sponsor[] }>(base(eventSlug, editionSlug))
  return data.data
}

export async function createSponsor(
  eventSlug: string,
  editionSlug: string,
  payload: SponsorFormData,
): Promise<Sponsor> {
  const { data } = await client.post<{ data: Sponsor }>(base(eventSlug, editionSlug), payload)
  return data.data
}

export async function updateSponsor(
  eventSlug: string,
  editionSlug: string,
  sponsorId: number,
  payload: Partial<SponsorFormData>,
): Promise<Sponsor> {
  const { data } = await client.patch<{ data: Sponsor }>(
    `${base(eventSlug, editionSlug)}/${sponsorId}`,
    payload,
  )
  return data.data
}

export async function deleteSponsor(
  eventSlug: string,
  editionSlug: string,
  sponsorId: number,
): Promise<void> {
  await client.delete(`${base(eventSlug, editionSlug)}/${sponsorId}`)
}

export async function uploadSponsorLogo(
  eventSlug: string,
  editionSlug: string,
  sponsorId: number,
  file: File,
): Promise<Sponsor> {
  const formData = new FormData()
  formData.append('logo', file)
  const { data } = await client.post<{ data: Sponsor }>(
    `${base(eventSlug, editionSlug)}/${sponsorId}/logo`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  return data.data
}

export async function deleteSponsorLogo(
  eventSlug: string,
  editionSlug: string,
  sponsorId: number,
): Promise<void> {
  await client.delete(`${base(eventSlug, editionSlug)}/${sponsorId}/logo`)
}
